module.exports = __webpack_public_path__ + "static/gloves-463e8b1b661e97eaf30adf6b47a76136.png";